// /components/reports/components/LessonOptions.js
import React, { useState, useEffect } from 'react';
import { Form, Stack } from 'react-bootstrap';
import { ErrorMsg } from '../../../utils/Toast'; // Adjust path as needed

import { getLessonsByClassId } from '../../../utils/class'; // Adjust path as needed
import { useSelector } from 'react-redux';

function LessonOptions({ selectedClass, selectedLessons, onChange }) {

  const {user} = useSelector((state) => state.loggedUser);
  const [lessons, setLessons] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!selectedClass) {
      setLessons([]);
      return;
    }

    const fetchLessons = async () => {
      setIsLoading(true);
      try {
        const res = await getLessonsByClassId(selectedClass,user?._id);
        setLessons(res.data?.lessons || []);
      } catch (e) {
        ErrorMsg('Failed to fetch lessons');
      } finally {
        setIsLoading(false);
      }
    };
    fetchLessons();
  }, [selectedClass]); // Re-fetch only when selectedClass changes

  return (
    <Stack gap={3} className="p-2 border rounded">
      <Form.Label>Lesson Options</Form.Label>
      <Form.Group controlId="lessonSelect">
        <Form.Label>Select Lessons</Form.Label>
        <Form.Select
          multiple
          htmlSize={5}
          name="selectedLessons"
          value={selectedLessons}
          onChange={onChange} // This is the multi-select handler
        >
          {isLoading && <option disabled>Loading lessons...</option>}
          {!isLoading && lessons.length === 0 && (
            <option disabled>No lessons found</option>
          )}
          {lessons.map((lesson) => (
            <option key={lesson._id} value={lesson._id}>
              {lesson.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Stack>
  );
}

export default LessonOptions;